/* istanbul ignore file */

export enum KeyingDialogType {
  ALERT = 'Ok',
  CONFIRM = 'Confirm',
}
